// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Reminder-limit toast ---
   Transient alert anchored above the footer when a reminder could not be set. Uses the same
   dark panel treatment as .login-modal but in a warning accent so it reads as a failure, and
   sits below the modal overlay z-index (1100) since it never competes with an open modal. */

.subscription-limit-toast {
  position: fixed;
  left: 50%;
  bottom: 1.5rem;
  transform: translateX(-50%);
  z-index: 1090;
  width: min(92vw, 26rem);
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.85rem 1rem;
  background: #2c2216;
  border: 1px solid #e0a33a;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  color: #f4e6cf;
  font-size: 0.9rem;
  line-height: 1.35;
  animation: subscription-limit-toast-in 0.18s ease-out;
}

.subscription-limit-toast__icon {
  flex: none;
  color: #e0a33a;
  font-size: 1rem;
  line-height: 1.35;
}

.subscription-limit-toast__message {
  margin: 0;
  flex: 1 1 auto;
}

.subscription-limit-toast__dismiss {
  flex: none;
  background: none;
  border: none;
  padding: 0 0.15rem;
  color: inherit;
  opacity: 0.7;
  cursor: pointer;
  font-size: 1.1rem;
  line-height: 1;
}

.subscription-limit-toast__dismiss:hover {
  opacity: 1;
}

@keyframes subscription-limit-toast-in {
  from {
    opacity: 0;
    transform: translate(-50%, 0.5rem);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

/* Respect users who ask for reduced motion: show the toast without the slide-in. */
@media (prefers-reduced-motion: reduce) {
  .subscription-limit-toast {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/subscription-limit-toast/subscription-limit-toast.css"],"names":[],"mappings":"AAAA;;;4FAG4F;;AAE5F;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA,mFAAmF;AACnF;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/* --- Reminder-limit toast ---\r\n   Transient alert anchored above the footer when a reminder could not be set. Uses the same\r\n   dark panel treatment as .login-modal but in a warning accent so it reads as a failure, and\r\n   sits below the modal overlay z-index (1100) since it never competes with an open modal. */\r\n\r\n.subscription-limit-toast {\r\n  position: fixed;\r\n  left: 50%;\r\n  bottom: 1.5rem;\r\n  transform: translateX(-50%);\r\n  z-index: 1090;\r\n  width: min(92vw, 26rem);\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.6rem;\r\n  padding: 0.85rem 1rem;\r\n  background: #2c2216;\r\n  border: 1px solid #e0a33a;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  color: #f4e6cf;\r\n  font-size: 0.9rem;\r\n  line-height: 1.35;\r\n  animation: subscription-limit-toast-in 0.18s ease-out;\r\n}\r\n\r\n.subscription-limit-toast__icon {\r\n  flex: none;\r\n  color: #e0a33a;\r\n  font-size: 1rem;\r\n  line-height: 1.35;\r\n}\r\n\r\n.subscription-limit-toast__message {\r\n  margin: 0;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.subscription-limit-toast__dismiss {\r\n  flex: none;\r\n  background: none;\r\n  border: none;\r\n  padding: 0 0.15rem;\r\n  color: inherit;\r\n  opacity: 0.7;\r\n  cursor: pointer;\r\n  font-size: 1.1rem;\r\n  line-height: 1;\r\n}\r\n\r\n.subscription-limit-toast__dismiss:hover {\r\n  opacity: 1;\r\n}\r\n\r\n@keyframes subscription-limit-toast-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translate(-50%, 0.5rem);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translate(-50%, 0);\r\n  }\r\n}\r\n\r\n/* Respect users who ask for reduced motion: show the toast without the slide-in. */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .subscription-limit-toast {\r\n    animation: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
